import { Link } from 'react-router-dom';
import '../styles/Footer.css';

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <div className="footer-container">
                <div className="footer-content">
                    <div className="footer-brand">
                        <img src="/images/logo.png" alt="Fotomista" className="footer-logo" />
                        <p className="footer-tagline">تجربة تصوير احترافية لمناسباتكم الخاصة</p>
                    </div>

                    <div className="footer-links">
                        <Link to="/terms">الشروط والأحكام</Link>
                        <span className="footer-divider">|</span>
                        <Link to="/privacy">سياسة الخصوصية</Link>
                        <span className="footer-divider">|</span>
                        <Link to="/contact">اتصل بنا</Link>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>© {currentYear} فوتوميستا (Fotomista). جميع الحقوق محفوظة.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
